<template>
    <span style="color:red" >[ERROR]</span>
</template>